import { create } from "zustand";
import { IDENTIFICATION, USER_LIST } from "../Utils/constant";
import { getAll, getOne } from "../services/service";
export const useStoreUser = create((set) => ({
  loading: false,
  loadingIdentification: false,
  data: [],
  userIdentification: null,
  identification: async (ref) => {
    set({
      loadingIdentification: true,
      userIdentification: null,
    });
    try {
      const identify = await getOne(IDENTIFICATION, ref);
      set({
        loadingIdentification: false,
        userIdentification: identify.data,
      });
    } catch (error) {
      set({
        loadingIdentification: true,
        userIdentification: {},
      });
    }
  },
  user: async (param) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const users = await getAll(USER_LIST, param, "");
      set({
        loading: false,
        data: users.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
